.container {
  container: setup-options / inline-size;
}

.options {
  grid-template-columns: minmax(0, 1fr);
}

@container setup-options (min-width: 36rem) {
  .options {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container setup-options (min-width: 56rem) {
  .options[data-columns="3"] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
